<template>
  <section class="global-box">
    <div class="content-box">
      <h2>Conteúdo Marketing</h2>
    </div>
  </section>
</template>

<script>
export default {
  name: 'content-session',
  props: {
    complete: {
      type: Boolean,
      default: true,
    },
    isFlutuation: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  data() {
    return {
      flutuation: false,
    };
  },
  methods: {
    updateScroll() {
      if (this.isFlutuation) {
        if (window.scrollY > 120) {
          this.flutuation = true;
        } else {
          this.flutuation = false;
        }
      }
    },
    routerDirect() {
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push({ path: '/' });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  section
    width: 100%
    height: 700px
  .global-box
    padding: 0 !important
    overflow: initial !important
</style>
